export const lottery = {
  lotteryPlay: "Jugar",
  lotteryResults: "Resultados",
  myLotteryTicket: "Mis Tickets",
  lotteryMyTickets: "Mis Tickets de Lotería",
  lotteryBackBtn: "Volver a Loterías",
  lotteryMyBets: "Tus apuestas",
  lotteryFloatButtonTitle: "Apuestas",
  lotteryTooltipText: "Mostrar todas mis apuestas",
  lotteryDraw: "Sorteo",
  lotteryAnimal: "Animalito",
  lotterySelectAnimal: "Selecciona un animalito",
  lotterySelectDraw: "Selecciona un sorteo",
  lotteryAmount: "Monto",
  lotteryTotalBet: "Total Apostado",
  lotteryBuyTicket: "Comprar Ticket",
  lotteryCreateTicket: "Creando ticket",
  lotteryCreatedTicket: "Ticket(s) creado(s) correctamente!",
  lotteryErrorTicket: "Error al crear el ticket",
  lotteryHideResults: "Ocultar Resultados",
  lotteryShowResults: "Mostrar Resultados",
  lotteryDrawActive: "Ruleta Activa",
  lotteryErrorLoadingData: "Error al cargar los datos",
  lotteryErrorInput: "Por favor, agrega al menos una apuesta antes de jugar.",
  lotteryErrorBalance: "Saldo insuficiente. Por favor, recargue su saldo.",
  lotteryErrorBetAmount: "La apuesta mínima es de 50 Bs.",
  lotteryErrorMinBetAmount: "La apuesta mínima es de {{min}} Bs.",
  lotteryErrorMaxBetAmount: "La apuesta máxima es de {{max}} Bs.",
  lotteryErrorBetStep: "La apuesta debe ser múltiplo de {{step}} (50, 60, 70...).",
  lotteryBetHintMin: "Mínimo {{min}} Bs",
  lotteryBetHintStep: "múltiplos de {{step}}",
  lotteryBetHintMax: "máximo {{max}} Bs",
  lotteryErrorSelectDrawAnimal: "Por favor, selecciona un sorteo, un animalito e ingresa un monto de apuesta válido.",
  lotteryMode: "Solo puedes seleccionar hasta 4 animalitos en modo Moderno.",
  lotteryTicketCreatedMessage: "Ticket creado correctamente",
  lotteryTicketCreatedMessageError: "Error al crear el ticket",
  lotteryCardGame: "Próximamente",
  lotteryModalCode: "Código de Ticket",
  lotteryModalDate: "Fecha de Creación",
  lotteryModalTotal: "Monto Total",
  lotteryModalWon: "Monto Ganado",
  lotteryModalAnimals: "Animalitos Jugados",
  lotteryModalTitle: "Detalles del Ticket",
  lotteryModalCancel: "Cancelar",
  lotteryModalConfirm: "Aceptar",
  lotteryModalAmount: "Monto",
  lotteryModalNoTickets: "No tienes tickets de lotería",
  lotteryTokenNotFound: "Ficha no encontrada",
  lotteryActiveRouletteResults: "Resultados de Ruleta Activa",
  lotteryGameWinner: "Ganador",
  lotteryGamePrize: "No Ganador",

  lotteryModalInput: "Ingresa el monto de tu apuesta",
  lotteryModalAddBet: "Agregar Apuesta",
  lotteryModalCancelBet: "Cancelar",
  lotteryTraditional: "Tradicional",
  lotteryModern: "Moderno",
  selectLotteryType: "Selecciona el tipo de Lotería",
  results: "Resultados",
  resultLotteryModern: "Resultado de Sorteo Moderno",
  resultLotteryTraditional: "Resultado de Sorteo Tradicional",
  lotteryDate: "Fecha de Sorteo",
  lotteryNoResults: "No hay resultados para esta fecha",
};
